<app-loader></app-loader>

<router-outlet></router-outlet>

<!-- Error Messages -->
<p-dialog [(visible)]="display" modal="modal" [responsive]="true">
  <p-header>
    {{messageObject?.header}}
  </p-header>
  {{messageObject?.message}}
  <p-footer>
    <button type="button" pButton (click)="display=false" label="Ok"></button>
  </p-footer>
</p-dialog>
